var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import Button from "@/components/ui/button/Button.vue";
import ContextMenu from "@/components/ui/context-menu/ContextMenu.vue";
import Panel from "@/components/ui/panel/Panel.vue";
import Select from "@/components/ui/select/Select.vue";
import { ChevronDownIcon, FilterIcon } from "lucide-vue-next";
import { computed, onMounted, ref, watch } from "vue";
import { fetchKpiGlobalPerformance, fetchWorkingDaysProgress, KPI_GLOBAL_PERFORMANCE_TYPES, } from "../../api";
import BaseKpiChart from "../shared/BaseKpiChart.vue";
import { getKpiGlobalPerformanceConfig } from "./config";
import { CHART_MAX_DECIMAL_PLACES, CHART_MIN_DECIMAL_PLACES, DEFAULT_KPI_GLOBAL_PERFORMANCE_TYPE } from "../../config";
export default /*@__PURE__*/ _defineComponent({
    __name: 'KpiGlobalPerformancePanel',
    props: {
        currentPeriodLabel: { type: String, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        // State
        const isLoading = ref(true);
        const error = ref(null);
        const kpiData = ref(null);
        const workingDaysProgress = ref(null);
        const selectedType = ref(DEFAULT_KPI_GLOBAL_PERFORMANCE_TYPE);
        const selectedDistributors = ref([]);
        const distributorSourceData = ref([]);
        // Computed
        const currentConfig = computed(() => getKpiGlobalPerformanceConfig(selectedType.value));
        const showDistributorSelect = computed(() => selectedType.value === "distribuidor");
        const distributorOptions = computed(() => {
            if (selectedType.value !== "distribuidor") {
                return [];
            }
            return distributorSourceData.value
                .map((item) => { var _a; return ((_a = item.distribuidor) === null || _a === void 0 ? void 0 : _a.trim()) || "(Sin nombre)"; })
                .filter((value, index, values) => value.length > 0 && values.indexOf(value) === index)
                .sort((left, right) => left.localeCompare(right, "es", { sensitivity: "base" }))
                .map((distributor) => ({
                label: distributor,
                value: distributor,
            }));
        });
        const typeDisplayText = computed(() => {
            const currentType = KPI_GLOBAL_PERFORMANCE_TYPES.find((type) => type.value === selectedType.value);
            return currentType ? currentType.label : "Tipo";
        });
        const typeMenuOptions = computed(() => {
            return KPI_GLOBAL_PERFORMANCE_TYPES.map((type) => ({
                label: type.label,
                value: type.value,
            }));
        });
        const isEmptyData = computed(() => {
            if (!kpiData.value)
                return true;
            if (Array.isArray(kpiData.value)) {
                return kpiData.value.length === 0;
            }
            return false;
        });
        // Methods
        const handleTypeSelect = (option) => __awaiter(this, void 0, void 0, function* () {
            selectedType.value = option.value;
            yield loadData();
        });
        const loadData = () => __awaiter(this, void 0, void 0, function* () {
            try {
                isLoading.value = true;
                error.value = null;
                const [workingDaysResponse, kpiResponse] = yield Promise.all([
                    fetchWorkingDaysProgress(),
                    fetchKpiGlobalPerformance({
                        show_before_4: true,
                        filter: selectedType.value,
                        distributors: selectedType.value === "distribuidor" ? selectedDistributors.value : undefined,
                    }),
                ]);
                workingDaysProgress.value = workingDaysResponse;
                kpiData.value = kpiResponse;
                if (selectedType.value === "distribuidor" && selectedDistributors.value.length === 0 && Array.isArray(kpiResponse)) {
                    distributorSourceData.value = kpiResponse;
                }
                if (selectedType.value !== "distribuidor") {
                    distributorSourceData.value = [];
                }
            }
            catch (err) {
                error.value = "Error al cargar los datos de KPI";
                console.error("Error loading KPI data:", err);
            }
            finally {
                isLoading.value = false;
            }
        });
        // Lifecycle
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield loadData();
        }));
        watch(showDistributorSelect, (isDistributorView) => {
            if (!isDistributorView && selectedDistributors.value.length > 0) {
                selectedDistributors.value = [];
            }
        });
        watch(selectedDistributors, () => __awaiter(this, void 0, void 0, function* () {
            if (!showDistributorSelect.value) {
                return;
            }
            yield loadData();
        }), { deep: true });
        watch(distributorOptions, (options) => {
            if (selectedDistributors.value.length === 0) {
                return;
            }
            const validValues = new Set(options.map((option) => option.value));
            selectedDistributors.value = selectedDistributors.value.filter((value) => validValues.has(value));
        });
        const __returned__ = { isLoading, error, kpiData, workingDaysProgress, selectedType, selectedDistributors, distributorSourceData, currentConfig, showDistributorSelect, distributorOptions, typeDisplayText, typeMenuOptions, isEmptyData, handleTypeSelect, loadData, Button, ContextMenu, Panel, Select, get ChevronDownIcon() { return ChevronDownIcon; }, get FilterIcon() { return FilterIcon; }, BaseKpiChart, get CHART_MAX_DECIMAL_PLACES() { return CHART_MAX_DECIMAL_PLACES; }, get CHART_MIN_DECIMAL_PLACES() { return CHART_MIN_DECIMAL_PLACES; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
